import { BaseConfig } from '../ServiceConfig';

export interface NotificationConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.NotificationServiceConfigData';
  url: string;
  appId: string;
}

export const NotificationConfigurationFields: (keyof NotificationConfiguration)[] = [
  'url',
  'appId',
];

export const BlankNotificationConfiguration: NotificationConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.NotificationServiceConfigData',
} as NotificationConfiguration;
